(function () {
  const roots = document.querySelectorAll('[data-classifieds-root]');
  if (!roots.length) return;

  const categoryLabels = {
    telescopes: 'Télescopes',
    mounts: 'Montures',
    eyepieces: 'Oculaires',
    'astro-cameras': 'Caméras astro',
    filters: 'Filtres',
    binoculars: 'Jumelles',
    accessories: 'Accessoires',
    'observatory-dome': 'Observatoire et dôme',
    'books-maps': 'Livres et cartes',
    'other-astro': 'Autres matériels astro'
  };

  const conditionLabels = {
    'like-new': 'Comme neuf',
    'very-good': 'Très bon état',
    good: 'Bon état',
    fair: 'État correct',
    'for-parts': 'Pour pièces'
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
  }[char]));

  const formatPrice = (listing) => new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: listing.currencyCode || 'EUR'
  }).format(Number(listing.priceCents || 0) / 100);

  const formatDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const truncate = (value, length) => {
    const text = String(value || '').trim();
    return text.length <= length ? text : `${text.slice(0, length - 1).trim()}…`;
  };

  const shippingLabel = (listing) => {
    if (listing && listing.shippingLabel) return String(listing.shippingLabel);
    const options = [];
    if (!listing || listing.handDeliveryAvailable !== false) options.push('Remise en main propre');
    if (listing && listing.shippingAvailable) options.push(listing.shippingPayer === 'seller' ? 'Expédition incluse par le vendeur' : 'Expédition possible, frais à la charge de l’acheteur');
    return options.join(' · ');
  };

  const placeSubtitle = (place) => [place.admin1, place.country].filter(Boolean).join(' - ');
  const vagueLocationFromPlace = (place) => [place.name, place.admin1 || place.country_code || place.country].filter(Boolean).join(', ');

  const searchPlaces = async (query) => {
    const url = new URL('https://geocoding-api.open-meteo.com/v1/search');
    url.searchParams.set('name', query.trim());
    url.searchParams.set('count', '8');
    url.searchParams.set('format', 'json');
    url.searchParams.set('language', 'fr');
    const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('location search failed');
    const data = await response.json();
    return Array.isArray(data.results) ? data.results.filter((item) => item && item.name && typeof item.latitude === 'number' && typeof item.longitude === 'number') : [];
  };

  const TRACK_API_URL = 'https://intelligence-api.pleiades.solutions/api/track';
  const trackedVisits = new Set();

  const trackVisit = (sourcePage) => {
    if (!sourcePage || trackedVisits.has(sourcePage)) return;
    trackedVisits.add(sourcePage);
    try {
      const url = new URL(TRACK_API_URL);
      url.searchParams.set('store_id', '1');
      url.searchParams.set('source_page', sourcePage);
      fetch(url.toString(), { method: 'GET', mode: 'no-cors' }).catch(() => {});
    } catch (e) { /* tracking is best-effort */ }
  };

  const listingUrl = (listing) => listing && listing.url ? String(listing.url) : '';

  const listingSlugFromPath = () => {
    const basePath = '/pages/petites-annonces';
    const currentPath = window.location.pathname.replace(/\/$/, '');
    if (!currentPath.startsWith(`${basePath}/`)) return '';
    return decodeURIComponent(currentPath.slice(basePath.length + 1).split('/')[0] || '');
  };

  const baseClassifiedsPath = () => '/pages/petites-annonces';

  const listingPath = (slug) => `${baseClassifiedsPath()}/${encodeURIComponent(slug)}`;

  const sellerFromUrl = () => {
    try {
      return new URLSearchParams(window.location.search).get('vendeur') || '';
    } catch (error) {
      return '';
    }
  };

  const sellerPath = (displayName) => {
    const params = new URLSearchParams(window.location.search);
    params.set('vendeur', displayName || '');
    return `${baseClassifiedsPath()}?${params.toString()}`;
  };

  const listingSlugFromUrl = (url) => {
    if (!url) return '';
    try {
      const parsed = new URL(String(url), window.location.origin);
      const basePath = baseClassifiedsPath();
      const path = parsed.pathname.replace(/\/$/, '');
      if (!path.startsWith(`${basePath}/`)) return '';
      return decodeURIComponent(path.slice(basePath.length + 1).split('/')[0] || '');
    } catch (error) {
      return '';
    }
  };

  const listingStatusLabel = (status) => {
    const normalized = String(status || '').toUpperCase();
    return statusLabels[normalized] || status || 'Statut inconnu';
  };

  const unavailableMessageForStatus = (status, fallback) => {
    const normalized = String(status || '').toUpperCase();
    if (normalized === 'REJECTED') return 'Cette annonce a été refusée et n’est pas visible publiquement.';
    if (normalized === 'ARCHIVED') return 'Cette annonce a été archivée.';
    if (normalized === 'EXPIRED') return 'Cette annonce a expiré.';
    if (normalized === 'SOLD') return 'Cette annonce est marquée comme vendue.';
    if (normalized === 'PENDING' || normalized === 'PENDING_REVIEW') return 'Cette annonce est en attente de validation.';
    return fallback || 'Cette annonce n’est pas accessible publiquement.';
  };

  const statusLabels = {
    DRAFT: 'Brouillon',
    PENDING: 'En validation',
    PENDING_REVIEW: 'En validation',
    APPROVED: 'Validée',
    PUBLISHED: 'Publiée',
    REJECTED: 'Refusée',
    ARCHIVED: 'Archivée',
    EXPIRED: 'Expirée',
    SOLD: 'Vendue'
  };

  const exampleListings = [
    {
      id: 'example-1',
      slug: 'example-telescope-dobson-250',
      title: 'Dobson 250 mm avec oculaires',
      description: 'Exemple d’annonce : télescope bien entretenu, vendu avec deux oculaires, chercheur et housse de protection.',
      category: 'telescopes',
      condition: 'very-good',
      brand: 'Sky-Watcher',
      model: 'Classic 250P',
      priceCents: 52000,
      currencyCode: 'EUR',
      approximateLocation: 'Lyon 69',
      sellerDisplayName: 'Annonce fictive',
      publishedAt: '2026-07-01T10:00:00.000Z',
      images: [{
        url: 'https://astronomy.store/cdn/shop/files/Dobson254mm-01_092da0cd-55bc-4962-81b3-9b4d722c7ec8.jpg?v=1778416646',
        altText: 'Télescope du catalogue Astronomy Store utilisé comme exemple visuel'
      }],
      isExample: true
    },
    {
      id: 'example-2',
      slug: 'example-monture-eq6',
      title: 'Monture équatoriale GoTo EQ6-R',
      description: 'Exemple d’annonce : monture précise pour astrophotographie, trépied inclus, traces normales d’utilisation.',
      category: 'mounts',
      condition: 'good',
      brand: 'Sky-Watcher',
      model: 'EQ6-R Pro',
      priceCents: 89000,
      currencyCode: 'EUR',
      approximateLocation: 'Nantes 44',
      sellerDisplayName: 'Annonce fictive',
      publishedAt: '2026-06-30T10:00:00.000Z',
      images: [{
        url: 'https://astronomy.store/cdn/shop/files/SW0396-1x1200_c5fc7825-0bac-427e-85e2-54d27b59d84a.jpg?v=1778448724&width=1100',
        altText: 'Monture du catalogue Astronomy Store utilisée comme exemple visuel'
      }],
      isExample: true
    },
    {
      id: 'example-3',
      slug: 'example-camera-asi',
      title: 'Caméra astro refroidie couleur',
      description: 'Exemple d’annonce : caméra CMOS avec câbles, bagues et valise de transport. Idéale ciel profond.',
      category: 'astro-cameras',
      condition: 'like-new',
      brand: 'ZWO',
      model: 'ASI533MC Pro',
      priceCents: 62000,
      currencyCode: 'EUR',
      approximateLocation: 'Toulouse 31',
      sellerDisplayName: 'Annonce fictive',
      publishedAt: '2026-06-29T10:00:00.000Z',
      images: [{
        url: 'https://astronomy.store/cdn/shop/files/ZWASI585MC-P-1x1200.jpg?v=1727948040&width=1100',
        altText: 'Caméra du catalogue Astronomy Store utilisée comme exemple visuel'
      }],
      isExample: true
    },
    {
      id: 'example-4',
      slug: 'example-oculaires',
      title: 'Lot de 3 oculaires grand champ',
      description: 'Exemple d’annonce : oculaires 8 mm, 14 mm et 24 mm en bon état, bouchons fournis.',
      category: 'eyepieces',
      condition: 'good',
      brand: 'Explore Scientific',
      model: '82 degrés',
      priceCents: 24000,
      currencyCode: 'EUR',
      approximateLocation: 'Bordeaux 33',
      sellerDisplayName: 'Annonce fictive',
      publishedAt: '2026-06-28T10:00:00.000Z',
      images: [{
        url: 'https://astronomy.store/cdn/shop/files/plossl-eyepiece_7ff3e989-a750-4a05-8c88-6b86b2457513.jpg?v=1773136576&width=1100',
        altText: 'Oculaire du catalogue Astronomy Store utilisé comme exemple visuel'
      }],
      isExample: true
    },
    {
      id: 'example-5',
      slug: 'example-filtre-duo-band',
      title: 'Filtre duo-band 2 pouces',
      description: 'Exemple d’annonce : filtre pour nébuleuses, filetage propre, conservé dans sa boîte.',
      category: 'filters',
      condition: 'very-good',
      brand: 'Optolong',
      model: 'L-eXtreme 2\"',
      priceCents: 14500,
      currencyCode: 'EUR',
      approximateLocation: 'Paris 75',
      sellerDisplayName: 'Annonce fictive',
      publishedAt: '2026-06-27T10:00:00.000Z',
      images: [{
        url: 'https://astronomy.store/cdn/shop/files/2_20250901175823_0161.jpg?v=1773135785&width=1100',
        altText: 'Filtre du catalogue Astronomy Store utilisé comme exemple visuel'
      }],
      isExample: true
    },
    {
      id: 'example-6',
      slug: 'example-jumelles-astro',
      title: 'Jumelles 15x70 pour observation',
      description: 'Exemple d’annonce : jumelles lumineuses avec adaptateur trépied, parfaites pour ciel profond grand champ.',
      category: 'binoculars',
      condition: 'good',
      brand: 'Celestron',
      model: 'SkyMaster 15x70',
      priceCents: 8500,
      currencyCode: 'EUR',
      approximateLocation: 'Rennes 35',
      sellerDisplayName: 'Annonce fictive',
      publishedAt: '2026-06-26T10:00:00.000Z',
      images: [{
        url: 'https://cdn.shopify.com/s/files/1/0741/2511/5657/files/82614_levenhuk-nitro-12x50-binoculars_00_fd397faf-947e-4bb8-b4c0-552ee7fceeae.jpg?v=1777526367',
        altText: 'Jumelles du catalogue Astronomy Store utilisées comme exemple visuel'
      }],
      isExample: true
    },
    {
      id: 'example-7',
      slug: 'example-correcteur-coma',
      title: 'Correcteur de coma pour Newton',
      description: 'Exemple d’annonce : accessoire optique en très bon état, livré avec bagues de raccordement.',
      category: 'accessories',
      condition: 'very-good',
      brand: 'Baader',
      model: 'MPCC Mark III',
      priceCents: 11500,
      currencyCode: 'EUR',
      approximateLocation: 'Grenoble 38',
      sellerDisplayName: 'Annonce fictive',
      publishedAt: '2026-06-25T10:00:00.000Z',
      images: [{
        url: 'https://cdn.shopify.com/s/files/1/0741/2511/5657/files/Tecnosky-Variabler-Flattener-1-0x-Full-Frame.jpg?v=1763783735',
        altText: 'Correcteur optique du catalogue Astronomy Store utilisé comme exemple visuel'
      }],
      isExample: true
    },
    {
      id: 'example-8',
      slug: 'example-coupole-observatoire',
      title: 'Mini observatoire de jardin',
      description: 'Exemple d’annonce : abri léger pour poste fixe, démontable, à venir récupérer sur place.',
      category: 'observatory-dome',
      condition: 'fair',
      brand: 'Pulsar',
      model: 'Dôme compact',
      priceCents: 120000,
      currencyCode: 'EUR',
      approximateLocation: 'Dijon 21',
      sellerDisplayName: 'Annonce fictive',
      publishedAt: '2026-06-24T10:00:00.000Z',
      images: [{
        url: 'https://astronomy.store/cdn/shop/files/Kopula-2M-bez-wiezy.jpg?v=1719414151',
        altText: 'Accessoire de télescope du catalogue Astronomy Store utilisé comme exemple visuel'
      }],
      isExample: true
    },
    {
      id: 'example-9',
      slug: 'example-atlas-ciel',
      title: 'Atlas du ciel et cartes lunaires',
      description: 'Exemple d’annonce : livres et cartes propres, annotations légères, très utiles pour préparer ses soirées.',
      category: 'books-maps',
      condition: 'good',
      brand: 'Cambridge',
      model: 'Star Atlas',
      priceCents: 3500,
      currencyCode: 'EUR',
      approximateLocation: 'Lille 59',
      sellerDisplayName: 'Annonce fictive',
      publishedAt: '2026-06-23T10:00:00.000Z',
      images: [{
        url: 'https://cdn.shopify.com/s/files/1/0741/2511/5657/files/74043_levenhuk-magnifier-zeno-gem-zm9_00_460c7b7f-dc5e-40d1-b676-48768290532e.jpg?v=1779163588',
        altText: 'Produit optique du catalogue Astronomy Store utilisé comme exemple visuel'
      }],
      isExample: true
    },
    {
      id: 'example-10',
      slug: 'example-lunette-guide',
      title: 'Lunette guide 50 mm complète',
      description: 'Exemple d’annonce : lunette guide, colliers et support chercheur. Convient pour setup nomade.',
      category: 'other-astro',
      condition: 'very-good',
      brand: 'SVBony',
      model: 'SV165',
      priceCents: 5500,
      currencyCode: 'EUR',
      approximateLocation: 'Marseille 13',
      sellerDisplayName: 'Annonce fictive',
      publishedAt: '2026-06-22T10:00:00.000Z',
      images: [{
        url: 'https://astronomy.store/cdn/shop/files/svbony-sv165-guiding-scope_d7cebeaf-ef7d-4934-a474-d80e55c74ee7.jpg?v=1778553903&width=1100',
        altText: 'Accessoire du catalogue Astronomy Store utilisé comme exemple visuel'
      }],
      isExample: true
    }
  ];

  const normalizeItems = (data, keys) => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    for (const key of keys) {
      if (Array.isArray(data[key])) return data[key];
    }
    return [];
  };

  const normalizeAccountPayload = (data) => ({
    profile: data && data.profile && data.profile.displayName ? data.profile : null,
    listings: normalizeItems(data, ['listings', 'items', 'classifieds', 'publications', 'ads']),
    conversations: normalizeItems(data, ['conversations', 'threads', 'messages', 'inbox']),
    emailNotificationsEnabled: data && data.emailNotificationsEnabled !== false,
    emailNotificationsDisabledAt: data && data.emailNotificationsDisabledAt ? data.emailNotificationsDisabledAt : null
  });

  roots.forEach((root) => {
    const apiBaseUrl = root.dataset.apiBaseUrl;
    const actionBaseUrl = root.dataset.actionBaseUrl || apiBaseUrl;
    const accountUrl = root.dataset.accountUrl || '';
    const loginUrl = root.dataset.loginUrl || '/account/login';
    const pageUrl = root.dataset.pageUrl || window.location.pathname;
    const initialListingSlug = listingSlugFromPath();
    const listNode = root.querySelector('[data-classifieds-list]');
    const marketplaceNode = root.querySelector('.classifieds__marketplace');
    const statusNode = root.querySelector('[data-classifieds-status]');
    const emptyNode = root.querySelector('[data-classifieds-empty]');
    const searchNode = root.querySelector('[data-classifieds-search]');
    const sortNode = root.querySelector('[data-classifieds-sort]');
    const paginationNode = root.querySelector('[data-classifieds-pagination]');
    const detailNode = root.querySelector('[data-classifieds-detail]');
    const initialListingsNode = root.querySelector('[data-classifieds-initial-listings]');
    const submitOverlay = root.querySelector('[data-classifieds-submit-overlay]');
    const form = root.querySelector('[data-classifieds-form]');
    const formStatus = root.querySelector('[data-classifieds-form-status]');
    const locationQuery = root.querySelector('[data-classifieds-location-query]');
    const locationResults = root.querySelector('[data-classifieds-location-results]');
    const shippingToggle = root.querySelector('[data-classifieds-shipping-toggle]');
    const shippingPayer = root.querySelector('[data-classifieds-shipping-payer]');
    const accountRoot = root.querySelector('[data-classifieds-account]');
    const accountOverlay = root.querySelector('[data-classifieds-account-overlay]');
    const accountStatus = root.querySelector('[data-classifieds-account-status]');
    const accountContent = root.querySelector('[data-classifieds-account-content]');
    const accountListingsNode = root.querySelector('[data-classifieds-account-listings]');
    const accountMessagesNode = root.querySelector('[data-classifieds-account-messages]');
    const accountProfilePanel = root.querySelector('[data-classifieds-profile-panel]');
    const pseudoField = root.querySelector('[data-classifieds-pseudo-field]');
    const emailNotificationsToggle = root.querySelector('[data-classifieds-email-notifications-toggle]');
    const emailNotificationsLabel = root.querySelector('[data-classifieds-email-notifications-label]');
    const fieldErrors = form ? Array.prototype.slice.call(form.querySelectorAll('[data-classifieds-field-error]')) : [];
    let listings = [];
    let currentCategory = '';
    let currentPage = 1;
    let detailTrigger = null;
    let accountTrigger = null;
    let editingListing = null;
    let activeListingSlug = initialListingSlug || '';
    const basePagePath = baseClassifiedsPath();
    let currentSellerDisplayName = sellerFromUrl();
    let accountListings = [];
    let accountEmailNotificationsEnabled = true;
    let accountProfileDisplayName = '';

    try {
      listings = initialListingsNode ? JSON.parse(initialListingsNode.textContent || '[]') : [];
    } catch (error) {
      listings = [];
    }

    const setStatus = (message) => {
      if (statusNode) statusNode.textContent = message || '';
    };

    const setAccountStatus = (message) => {
      if (accountStatus) accountStatus.textContent = message || '';
    };

    const openAccountModal = (trigger) => {
      if (!accountOverlay || !accountRoot) return;
      accountTrigger = trigger || null;
      accountOverlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const closeButton = accountOverlay.querySelector('[data-classifieds-close-account]');
      const focusTarget = closeButton || accountRoot;
      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
      loadAccount();
    };

    const closeAccountModal = () => {
      if (!accountOverlay) return;
      accountOverlay.hidden = true;
      if ((detailNode && !detailNode.hidden) || (submitOverlay && !submitOverlay.hidden)) return;
      document.documentElement.style.overflow = '';
      if (accountTrigger && typeof accountTrigger.focus === 'function') accountTrigger.focus({ preventScroll: true });
      accountTrigger = null;
    };

    const fetchJson = async (url, options) => {
      const response = await fetch(url, options || { headers: { Accept: 'application/json' } });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const error = new Error(data.error || data.message || 'request failed');
        error.status = response.status;
        error.data = data;
        throw error;
      }
      return data;
    };

    const clearFormErrors = () => {
      if (!form) return;
      fieldErrors.forEach((node) => {
        node.textContent = '';
      });
      form.querySelectorAll('.classifieds__field--invalid').forEach((field) => {
        field.classList.remove('classifieds__field--invalid');
        field.removeAttribute('aria-invalid');
      });
    };

    const setFormFieldError = (name, message) => {
      if (!form || !name || !message) return;
      const field = form.elements[name];
      const errorNode = form.querySelector(`[data-classifieds-field-error="${name}"]`);
      if (field && typeof field.setAttribute === 'function') {
        field.classList.add('classifieds__field--invalid');
        field.setAttribute('aria-invalid', 'true');
      }
      if (errorNode) errorNode.textContent = message;
    };

    const normalizeSubmitErrors = (data) => {
      const errors = [];
      const append = (field, message) => {
        if (message) errors.push({ field, message: String(message) });
      };
      if (data && data.fieldErrors && typeof data.fieldErrors === 'object') {
        Object.keys(data.fieldErrors).forEach((field) => append(field, data.fieldErrors[field]));
      }
      if (Array.isArray(data && data.errors)) {
        data.errors.forEach((error) => {
          if (typeof error === 'string') append('', error);
          else append(error.field || error.path || error.name || '', error.message || error.error);
        });
      }
      const message = String((data && (data.error || data.message)) || '').trim();
      if (message) {
        if (/title and description are too short/i.test(message)) {
          append('title', message);
          append('description', message);
        } else {
          append('', message);
        }
      }
      return errors;
    };

    const showSubmitErrors = (data, fallbackMessage) => {
      clearFormErrors();
      const errors = normalizeSubmitErrors(data);
      let firstInvalidField = null;
      errors.forEach((error) => {
        if (error.field && form && form.elements[error.field]) {
          setFormFieldError(error.field, error.message);
          if (!firstInvalidField) firstInvalidField = form.elements[error.field];
        }
      });
      const generalError = errors.find((error) => !error.field);
      if (formStatus) formStatus.textContent = generalError ? generalError.message : (fallbackMessage || 'Impossible d’envoyer l’annonce.');
      if (firstInvalidField && typeof firstInvalidField.focus === 'function') firstInvalidField.focus({ preventScroll: true });
    };

    const priceValue = (listing) => {
      const amount = Number(listing.priceCents || 0) / 100;
      return Number.isFinite(amount) ? String(amount).replace('.', ',') : '';
    };

    const setFormValue = (name, value) => {
      if (!form || !form.elements[name]) return;
      form.elements[name].value = value == null ? '' : String(value);
    };

    const setFormChecked = (name, checked) => {
      if (!form || !form.elements[name]) return;
      const field = form.elements[name];
      if (typeof field.length === 'number' && !field.tagName) {
        Array.prototype.forEach.call(field, (item) => {
          if (item && item.value === String(checked)) item.checked = true;
        });
        return;
      }
      field.checked = Boolean(checked);
    };

    const syncShippingPayerVisibility = () => {
      if (shippingPayer) shippingPayer.hidden = !(shippingToggle && shippingToggle.checked);
    };

    const ensureSubmitLocationAndDelivery = () => {
      if (!form) return true;
      const errors = [];
      const latitude = form.elements.locationLatitude && String(form.elements.locationLatitude.value || '').trim();
      const longitude = form.elements.locationLongitude && String(form.elements.locationLongitude.value || '').trim();
      const handDelivery = form.elements.handDeliveryAvailable && form.elements.handDeliveryAvailable.checked;
      const shipping = form.elements.shippingAvailable && form.elements.shippingAvailable.checked;
      if (!latitude || !longitude) {
        errors.push({ field: 'approximateLocation', message: 'Sélectionnez une ville dans la liste pour valider la localisation.' });
      }
      if (!handDelivery && !shipping) {
        errors.push({ field: 'handDeliveryAvailable', message: 'Choisissez au moins une remise en main propre ou une expédition.' });
      }
      if (!errors.length) return true;
      showSubmitErrors({ errors }, 'Certains champs obligatoires sont incomplets.');
      return false;
    };

    const setLocationFields = (place) => {
      if (!form || !place) return;
      setFormValue('approximateLocation', vagueLocationFromPlace(place));
      setFormValue('locationCity', place.name || '');
      setFormValue('locationAdmin1', place.admin1 || '');
      setFormValue('locationCountry', place.country || '');
      setFormValue('locationCountryCode', place.country_code || '');
      setFormValue('locationLatitude', place.latitude || '');
      setFormValue('locationLongitude', place.longitude || '');
      if (locationResults) locationResults.hidden = true;
    };

    const clearPreciseLocationFields = () => {
      setFormValue('locationCity', '');
      setFormValue('locationAdmin1', '');
      setFormValue('locationCountry', '');
      setFormValue('locationCountryCode', '');
      setFormValue('locationLatitude', '');
      setFormValue('locationLongitude', '');
    };

    const renderLocationResults = (places) => {
      if (!locationResults) return;
      if (!places.length) {
        locationResults.innerHTML = '<p class="caption-large">Aucune ville trouvée.</p>';
        locationResults.hidden = false;
        return;
      }
      locationResults.innerHTML = places.map((place, index) => `<button type="button" class="classifieds__location-result" data-classifieds-location-index="${index}"><strong>${escapeHtml(place.name)}</strong><span>${escapeHtml(placeSubtitle(place))}</span></button>`).join('');
      locationResults.hidden = false;
      locationResults._places = places;
    };

    const runLocationSearch = async () => {
      if (!locationQuery) return;
      const query = locationQuery.value.trim();
      if (query.length < 2) return;
      try {
        renderLocationResults(await searchPlaces(query));
      } catch (error) {
        if (locationResults) {
          locationResults.innerHTML = '<p class="caption-large">La recherche de ville a échoué. Essayez une autre ville.</p>';
          locationResults.hidden = false;
        }
      }
    };

    const resetSubmitFormMode = () => {
      editingListing = null;
      if (!form) return;
      form.reset();
      form.dataset.mode = 'create';
      form.removeAttribute('data-listing-id');
      const title = submitOverlay && submitOverlay.querySelector('#classifieds-submit-title');
      const eyebrow = submitOverlay && submitOverlay.querySelector('.classifieds__eyebrow');
      const note = submitOverlay && submitOverlay.querySelector('.classifieds__submit-note');
      const button = form.querySelector('button[type="submit"]');
      if (title) title.textContent = 'Déposer une annonce';
      if (eyebrow) eyebrow.textContent = 'Publication gratuite';
      if (note) note.textContent = 'Les coordonnées et liens externes sont refusés dans le contenu public. Les images sont vérifiées avant publication.';
      if (button) button.textContent = 'Soumettre à validation';
      if (formStatus) formStatus.textContent = '';
      if (pseudoField) pseudoField.hidden = Boolean(accountProfileDisplayName);
      clearPreciseLocationFields();
      setFormChecked('handDeliveryAvailable', true);
      setFormChecked('shippingAvailable', false);
      if (form.elements.shippingPayer) form.elements.shippingPayer.value = 'buyer';
      syncShippingPayerVisibility();
      clearFormErrors();
    };

    const openEditListing = (listing) => {
      if (!form || !listing || !listing.id) return;
      editingListing = listing;
      clearFormErrors();
      form.dataset.mode = 'edit';
      form.dataset.listingId = listing.id;
      const title = submitOverlay && submitOverlay.querySelector('#classifieds-submit-title');
      const eyebrow = submitOverlay && submitOverlay.querySelector('.classifieds__eyebrow');
      const note = submitOverlay && submitOverlay.querySelector('.classifieds__submit-note');
      const button = form.querySelector('button[type="submit"]');
      if (title) title.textContent = 'Modifier et renvoyer l’annonce';
      if (eyebrow) eyebrow.textContent = 'Annonce refusée';
      if (note) note.textContent = 'Corrigez les points indiqués ci-dessous. Vous pouvez renvoyer cette annonce une fois par jour.';
      if (button) button.textContent = 'Renvoyer à validation';
      setFormValue('title', listing.title || '');
      setFormValue('category', listing.category || 'other-astro');
      setFormValue('brand', listing.brand || '');
      setFormValue('model', listing.model || '');
      setFormValue('condition', listing.condition || 'good');
      setFormValue('price', priceValue(listing));
      setFormValue('approximateLocation', listing.approximateLocation || '');
      setFormValue('locationCity', listing.location && listing.location.city ? listing.location.city : '');
      setFormValue('locationAdmin1', listing.location && listing.location.admin1 ? listing.location.admin1 : '');
      setFormValue('locationCountry', listing.location && listing.location.country ? listing.location.country : '');
      setFormValue('locationCountryCode', listing.location && listing.location.countryCode ? listing.location.countryCode : '');
      setFormValue('locationLatitude', listing.location && listing.location.latitude != null ? listing.location.latitude : '');
      setFormValue('locationLongitude', listing.location && listing.location.longitude != null ? listing.location.longitude : '');
      setFormChecked('handDeliveryAvailable', listing.handDeliveryAvailable !== false);
      setFormChecked('shippingAvailable', Boolean(listing.shippingAvailable));
      if (form.elements.shippingPayer) form.elements.shippingPayer.value = listing.shippingPayer || 'buyer';
      syncShippingPayerVisibility();
      setFormValue('sellerDisplayName', accountProfileDisplayName || listing.sellerDisplayName || '');
      setFormValue('description', listing.description || '');
      if (pseudoField) pseudoField.hidden = Boolean(accountProfileDisplayName);
      if (form.elements.acceptedTerms) form.elements.acceptedTerms.checked = true;
      if (formStatus) formStatus.textContent = 'Les images actuelles sont conservées si vous ne choisissez pas de nouveaux fichiers.';
      openSubmit();
    };

    const normalizeText = (value) => String(value || '').toLocaleLowerCase('fr-FR');

    const listingMatchesSearch = (listing) => {
      if (!searchNode) return true;
      const query = normalizeText(searchNode.value).trim();
      if (!query) return true;
      return [listing.title, listing.description, listing.brand, listing.model, listing.approximateLocation, listing.sellerDisplayName, listing.categoryLabel, listing.conditionLabel]
        .some((value) => normalizeText(value).includes(query));
    };

    const listingMatchesCategory = (listing) => {
      if (!currentCategory) return true;
      return listing.category === currentCategory || listing.categorySlug === currentCategory;
    };

    const listingMatchesSeller = (listing) => {
      if (!currentSellerDisplayName) return true;
      return normalizeText(listing.sellerDisplayName).trim() === normalizeText(currentSellerDisplayName).trim();
    };

    const sortListings = (items) => {
      const mode = sortNode ? sortNode.value : 'recent';
      return [...items].sort((a, b) => {
        if (mode === 'price-asc') return Number(a.priceCents || 0) - Number(b.priceCents || 0);
        if (mode === 'price-desc') return Number(b.priceCents || 0) - Number(a.priceCents || 0);
        return new Date(b.publishedAt || 0).getTime() - new Date(a.publishedAt || 0).getTime();
      });
    };

    const renderCard = (listing) => {
      const image = listing.images && listing.images[0];
      const detailUrl = listingUrl(listing);
      const listingSlug = listing.slug || listingSlugFromUrl(detailUrl);
      const isExample = Boolean(listing.isExample);
      const openAttribute = !isExample && listingSlug ? ` data-classifieds-open="${escapeHtml(listingSlug)}"` : '';
      const cardClass = `classifieds-card${isExample ? ' classifieds-card--example' : ''}`;
      const imageHtml = image
        ? `<img src="${escapeHtml(image.url)}" alt="${escapeHtml(image.altText || listing.title)}" loading="${isExample ? 'eager' : 'lazy'}">`
        : `<span class="classifieds-card__placeholder">${isExample ? 'Exemple de photo' : 'Image en attente'}</span>`;
      const categoryLabel = listing.categoryLabel || categoryLabels[listing.category] || listing.category;
      const conditionLabel = listing.conditionLabel || conditionLabels[listing.condition] || listing.condition;
      const meta = [categoryLabel, conditionLabel].filter(Boolean).join(' · ');
      const brandModel = [listing.brand, listing.model].filter(Boolean).join(' ');
      const publishedAt = formatDate(listing.publishedAt);
      const transport = shippingLabel(listing);
      const sellerDisplayName = listing.sellerDisplayName || 'Client Astronomy Store';
      const sellerHtml = isExample
        ? `<span class="caption-large">${escapeHtml(sellerDisplayName)}</span>`
        : `<a class="classifieds-card__seller-link caption-large" href="${escapeHtml(sellerPath(sellerDisplayName))}" data-classifieds-seller="${escapeHtml(sellerDisplayName)}">${escapeHtml(sellerDisplayName)}</a>`;
      const mediaHref = isExample ? '#deposer-annonce' : detailUrl || (listingSlug ? listingPath(listingSlug) : '#');
      const footerLink = isExample
        ? '<span class="classifieds-card__example-note">Exemple fictif</span>'
        : `<a class="classifieds-card__link" href="${escapeHtml(detailUrl || '#')}"${openAttribute}>Voir l'annonce</a>`;

      return `
        <article class="${cardClass}">
          <a class="classifieds-card__media" href="${escapeHtml(mediaHref)}"${openAttribute}${isExample ? ' aria-label="Exemple d’annonce fictive"' : ''}>
            ${imageHtml}
            ${isExample ? '<span class="classifieds-card__sample-badge">Exemple</span>' : ''}
          </a>
          <div class="classifieds-card__content">
            <h2 class="classifieds-card__title h4">${escapeHtml(listing.title)}</h2>
            <div class="classifieds-card__price">${escapeHtml(formatPrice(listing))}</div>
            <div class="classifieds-card__meta caption-large">${escapeHtml(meta)}</div>
            ${listing.approximateLocation ? `<div class="classifieds-card__location caption-large">${escapeHtml(listing.approximateLocation)}</div>` : ''}
            ${transport ? `<div class="classifieds-card__location caption-large">${escapeHtml(transport)}</div>` : ''}
            ${publishedAt ? `<div class="classifieds-card__date caption-large">Publiée le ${escapeHtml(publishedAt)}</div>` : ''}
            ${brandModel ? `<div class="classifieds-card__seller caption-large">${escapeHtml(brandModel)}</div>` : ''}
            <p class="classifieds-card__description">${escapeHtml(truncate(listing.description, 110))}</p>
            <div class="classifieds-card__footer">
              ${sellerHtml}
              ${footerLink}
            </div>
          </div>
        </article>`;
    };

    const renderCurrentListings = () => {
      if (!listNode) return;
      const visibleRealListings = sortListings(listings.filter(listingMatchesSeller).filter(listingMatchesCategory).filter(listingMatchesSearch));
      const exampleSlots = Math.max(0, 10 - visibleRealListings.length);
      const visibleExamples = exampleListings
        .filter(listingMatchesSeller)
        .filter(listingMatchesCategory)
        .filter(listingMatchesSearch)
        .slice(0, exampleSlots);
      const visibleListings = visibleRealListings.concat(visibleExamples);
      listNode.innerHTML = visibleListings.length ? visibleListings.map(renderCard).join('') : '';
      if (emptyNode) emptyNode.hidden = true;
      if (currentSellerDisplayName) setStatus(`${visibleRealListings.length} annonce${visibleRealListings.length > 1 ? 's' : ''} de ${currentSellerDisplayName}.`);
      else if (visibleRealListings.length && visibleExamples.length) setStatus(`${visibleRealListings.length} annonce${visibleRealListings.length > 1 ? 's' : ''} réelle${visibleRealListings.length > 1 ? 's' : ''} et ${visibleExamples.length} exemple${visibleExamples.length > 1 ? 's' : ''} fictif${visibleExamples.length > 1 ? 's' : ''} affiché${visibleExamples.length > 1 ? 's' : ''}.`);
      else if (!visibleRealListings.length && visibleExamples.length) setStatus('Exemples d’annonces fictives - déposez la vôtre pour apparaître ici.');
      else if (!visibleListings.length) setStatus('Aucune annonce ne correspond à cette recherche.');
      else setStatus(`${visibleListings.length} annonce${visibleListings.length > 1 ? 's' : ''} affichée${visibleListings.length > 1 ? 's' : ''}`);
    };

    const renderPagination = (data) => {
      if (!paginationNode) return;
      if (!data.totalPages || data.totalPages < 2) {
        paginationNode.innerHTML = '';
        return;
      }
      paginationNode.innerHTML = `
        <button class="button button--secondary" type="button" data-classifieds-page="${data.page - 1}"${data.page <= 1 ? ' disabled' : ''}>Précédent</button>
        <span class="caption-large">Page ${data.page} / ${data.totalPages}</span>
        <button class="button button--secondary" type="button" data-classifieds-page="${data.page + 1}"${data.page >= data.totalPages ? ' disabled' : ''}>Suivant</button>`;
    };

    const renderAccountListings = (items) => {
      if (!accountListingsNode) return;
      if (!items.length) {
        accountListingsNode.innerHTML = '<p class="classifieds__account-empty">Vous n’avez pas encore déposé d’annonce.</p>';
        return;
      }
      accountListingsNode.innerHTML = items.map((listing) => {
        const status = String(listing.status || listing.statusLabel || '').toUpperCase();
        const statusLabel = listing.statusLabel || statusLabels[status] || listing.status || 'Statut inconnu';
        const detailUrl = listingUrl(listing);
        const image = listing.images && listing.images[0];
        const imageHtml = image && image.url
          ? `<img src="${escapeHtml(image.url)}" alt="${escapeHtml(image.altText || listing.title || 'Annonce')}" loading="lazy">`
          : '<span>Photo</span>';
        const titleHtml = detailUrl
          ? `<a href="${escapeHtml(detailUrl)}">${escapeHtml(listing.title || 'Annonce sans titre')}</a>`
          : escapeHtml(listing.title || 'Annonce sans titre');
        const messageCount = Number(listing.unreadMessageCount || listing.unreadMessages || listing.messageCount || 0);
        const rejectionReasons = Array.isArray(listing.rejectionReasons) ? listing.rejectionReasons.filter(Boolean) : [];
        const rejectionHtml = status === 'REJECTED' && rejectionReasons.length
          ? `<details class="classifieds-account-item__rejection"><summary>Voir les motifs du refus</summary><ul>${rejectionReasons.map((reason) => `<li>${escapeHtml(reason)}</li>`).join('')}</ul></details>`
          : '';
        const editHtml = listing.id && status === 'REJECTED' && listing.canResubmit
          ? `<button class="classifieds-account-action classifieds-account-action--primary" type="button" data-classifieds-edit-listing="${escapeHtml(listing.id)}">Modifier</button>`
          : '';
        const resubmitLimitHtml = status === 'REJECTED' && !listing.canResubmit
          ? `<p class="classifieds-account-item__limit">Modification déjà envoyée aujourd’hui. Réessayez ${listing.resubmitAvailableAt ? `le ${escapeHtml(new Date(listing.resubmitAvailableAt).toLocaleDateString('fr-FR'))}` : 'demain'}.</p>`
          : '';
        const canRemove = listing.id && status !== 'REMOVED';
        const removeHtml = canRemove
          ? `<button class="classifieds-account-action classifieds-account-action--danger" type="button" data-classifieds-remove-listing="${escapeHtml(listing.id)}">Supprimer</button>`
          : '';
        const createdAt = formatDate(listing.publishedAt || listing.createdAt || listing.updatedAt);
        const price = listing.priceCents == null ? '' : formatPrice(listing);
        return `<article class="classifieds-account-item">
          <div class="classifieds-account-item__image">${imageHtml}</div>
          <div class="classifieds-account-item__main">
            <div class="classifieds-account-item__title-row">
              <h4>${titleHtml}</h4>
              <span class="classifieds-status-badge classifieds-status-badge--${escapeHtml(status.toLowerCase() || 'unknown')}">${escapeHtml(statusLabel)}</span>
            </div>
            ${price ? `<div class="classifieds-account-item__price">${escapeHtml(price)}</div>` : ''}
            <p class="classifieds-account-item__summary">${[listing.categoryLabel, createdAt ? `Créée ${createdAt}` : '', listing.approximateLocation].filter(Boolean).map(escapeHtml).join(' · ')}</p>
            ${rejectionHtml}
            ${resubmitLimitHtml}
            <div class="classifieds-account-item__actions">
              ${editHtml}
              ${removeHtml}
            </div>
          </div>
        </article>`;
      }).join('');
    };

    const removeAccountListing = async (listingId, trigger) => {
      if (!listingId || !actionBaseUrl) return;
      const listing = accountListings.find((item) => item && item.id === listingId);
      const label = listing && listing.title ? `« ${listing.title} »` : 'cette annonce';
      if (!window.confirm(`Masquer / supprimer ${label} ? Elle ne sera plus visible publiquement.`)) return;
      const previousText = trigger ? trigger.textContent : '';
      if (trigger) {
        trigger.disabled = true;
        trigger.textContent = 'Suppression...';
      }
      setAccountStatus('Suppression de l’annonce...');
      try {
        const response = await fetch(`${actionBaseUrl.replace(/\/$/, '')}/${encodeURIComponent(listingId)}`, {
          method: 'DELETE',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || 'Suppression impossible');
        await loadAccount();
        listings = listings.filter((item) => item.id !== listingId);
        renderCurrentListings();
        setAccountStatus('Annonce supprimée. Elle n’est plus visible publiquement.');
      } catch (error) {
        setAccountStatus(error.message || 'Impossible de supprimer l’annonce pour le moment.');
      } finally {
        if (trigger) {
          trigger.disabled = false;
          trigger.textContent = previousText;
        }
      }
    };

    const renderMessageSnippet = (conversation) => {
      const messages = Array.isArray(conversation.messages) ? conversation.messages : [];
      const lastMessage = conversation.lastMessage || messages[messages.length - 1] || conversation;
      const body = lastMessage.body || lastMessage.message || lastMessage.text || conversation.preview || '';
      const author = lastMessage.senderDisplayName || lastMessage.authorDisplayName || lastMessage.senderName || conversation.senderDisplayName || '';
      const createdAt = lastMessage.createdAt || lastMessage.sentAt || conversation.updatedAt || conversation.createdAt || '';
      return { body, author, createdAt };
    };

    const renderAccountMessages = (items) => {
      if (!accountMessagesNode) return;
      if (!items.length) {
        accountMessagesNode.innerHTML = '<div class="classifieds__account-empty classifieds__account-empty--panel"><strong>Aucun message</strong><span>Les conversations avec les acheteurs apparaîtront ici.</span></div>';
        return;
      }
      const activeConversation = items[0];
      const activeSnippet = renderMessageSnippet(activeConversation || {});
      const activeListingTitle = activeConversation ? activeConversation.listingTitle || (activeConversation.listing && activeConversation.listing.title) || 'Conversation' : 'Conversation';
      const messageRows = items.map((conversation, index) => {
        const snippet = renderMessageSnippet(conversation);
        const unreadCount = Number(conversation.unreadCount || conversation.unreadMessageCount || 0);
        const listingTitle = conversation.listingTitle || (conversation.listing && conversation.listing.title) || 'Conversation';
        const image = conversation.listing && conversation.listing.images && conversation.listing.images[0];
        const imageHtml = image && image.url ? `<img src="${escapeHtml(image.url)}" alt="${escapeHtml(listingTitle)}" loading="lazy">` : '<span></span>';
        return `<article class="classifieds-account-message${unreadCount ? ' is-unread' : ''}${index === 0 ? ' is-active' : ''}">
          <div class="classifieds-account-message__thumb">${imageHtml}</div>
          <div class="classifieds-account-message__heading">
            <h4>${escapeHtml(listingTitle)}</h4>
            ${unreadCount ? `<span class="classifieds-message-badge">${unreadCount} non lu${unreadCount > 1 ? 's' : ''}</span>` : ''}
            <p>${escapeHtml(truncate(snippet.body || 'Message sans aperçu', 82))}</p>
            <div class="caption-large">${[snippet.author, snippet.createdAt ? formatDate(snippet.createdAt) : ''].filter(Boolean).map(escapeHtml).join(' · ')}</div>
          </div>
        </article>`;
      }).join('');
      accountMessagesNode.innerHTML = `<div class="classifieds-messages-layout">
        <div class="classifieds-messages-list"><div class="classifieds-message-tabs"><span>Tout</span><span>Non lus</span></div>${messageRows}</div>
        <div class="classifieds-message-thread">
          <div class="classifieds-message-thread__buyer"><strong>À propos de cet acheteur</strong><span>Membre de la communauté Astronomy Store</span></div>
          <div class="classifieds-message-thread__date">${activeSnippet.createdAt ? formatDate(activeSnippet.createdAt) : ''}</div>
          <div class="classifieds-message-bubble classifieds-message-bubble--incoming">${escapeHtml(activeSnippet.body || 'Aucun aperçu disponible.')}</div>
          <div class="classifieds-message-bubble classifieds-message-bubble--outgoing">Bonjour, oui l'article est toujours disponible.</div>
          <div class="classifieds-message-compose"><button type="button">+</button><input type="text" placeholder="Écrivez votre message" aria-label="Écrivez votre message"><button type="button">Envoyer</button></div>
        </div>
        <aside class="classifieds-message-sidebar"><div class="classifieds-message-avatar">${escapeHtml((activeSnippet.author || 'A').charAt(0).toUpperCase())}</div><strong>${escapeHtml(activeSnippet.author || 'Acheteur')}</strong><span>Dernière activité récente</span><p>${escapeHtml(activeListingTitle)}</p></aside>
      </div>`;
    };

    const renderEmailNotifications = (enabled, disabledAt) => {
      accountEmailNotificationsEnabled = enabled !== false;
      if (emailNotificationsLabel) {
        emailNotificationsLabel.textContent = accountEmailNotificationsEnabled
          ? 'Vous recevez les emails de review et de nouveaux messages.'
          : `Emails désactivés${disabledAt ? ` depuis le ${new Date(disabledAt).toLocaleDateString('fr-FR')}` : ''}. Les notifications dans votre espace restent actives.`;
      }
      if (emailNotificationsToggle) {
        emailNotificationsToggle.disabled = false;
        emailNotificationsToggle.textContent = accountEmailNotificationsEnabled ? 'Désactiver' : 'Réactiver';
        emailNotificationsToggle.setAttribute('aria-pressed', accountEmailNotificationsEnabled ? 'true' : 'false');
      }
    };

    const renderAccount = (data) => {
      const account = normalizeAccountPayload(data);
      accountListings = account.listings;
      accountProfileDisplayName = account.profile && account.profile.displayName ? String(account.profile.displayName) : '';
      if (pseudoField) pseudoField.hidden = Boolean(accountProfileDisplayName);
      if (accountProfilePanel) {
        accountProfilePanel.hidden = !accountProfileDisplayName;
        accountProfilePanel.innerHTML = accountProfileDisplayName
          ? `<div class="classifieds-profile-summary"><strong>Pseudo public</strong><span>${escapeHtml(accountProfileDisplayName)}</span></div>`
          : '';
      }
      accountListingsNode && (accountListingsNode._classifiedListings = accountListings);
      renderAccountListings(account.listings);
      renderAccountMessages(account.conversations);
      renderEmailNotifications(account.emailNotificationsEnabled, account.emailNotificationsDisabledAt);
      if (accountContent) accountContent.hidden = false;
      setAccountStatus('');
    };

    const updateEmailNotifications = async () => {
      if (!actionBaseUrl || !emailNotificationsToggle) return;
      const enable = !accountEmailNotificationsEnabled;
      const previousText = emailNotificationsToggle.textContent;
      emailNotificationsToggle.disabled = true;
      emailNotificationsToggle.textContent = enable ? 'Activation...' : 'Désactivation...';
      setAccountStatus(enable ? 'Activation des emails...' : 'Désactivation des emails...');
      try {
        const data = await fetchJson(`${actionBaseUrl.replace(/\/$/, '')}/email-notifications/${enable ? 'enable' : 'disable'}`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        renderEmailNotifications(data.emailNotificationsEnabled, data.emailNotificationsDisabledAt);
        setAccountStatus(enable ? 'Emails petites annonces réactivés.' : 'Emails petites annonces désactivés.');
      } catch (error) {
        emailNotificationsToggle.disabled = false;
        emailNotificationsToggle.textContent = previousText;
        setAccountStatus(error.message || 'Impossible de modifier les notifications email.');
      }
    };

    const ownedListingFor = (listing) => {
      if (!listing || !Array.isArray(accountListings)) return null;
      return accountListings.find((item) => item && (
        item.id === listing.id ||
        item.slug === listing.slug ||
        item.handle === listing.slug ||
        item.listingSlug === listing.slug
      )) || null;
    };

    const loadAccount = async () => {
      if (!accountRoot || !accountUrl) return;
      if (accountContent) accountContent.hidden = true;
      setAccountStatus('Chargement de votre espace...');
      try {
        const data = await fetchJson(accountUrl, { headers: { Accept: 'application/json' } });
        renderAccount(data);
      } catch (error) {
        setAccountStatus(error.status === 401 ? 'Connectez-vous pour charger vos annonces et messages.' : 'Impossible de charger vos annonces et messages pour le moment.');
      }
    };

    const loadListings = async () => {
      if (!listNode) return;
      if (listings.length) {
        const visibleListings = listings.filter(listingMatchesCategory);
        renderCurrentListings();
        renderPagination({ page: 1, totalPages: 1 });
        return listings;
      }
      if (!apiBaseUrl) return listings;
      setStatus('Chargement des annonces...');
      if (emptyNode) emptyNode.hidden = true;
      const url = new URL(apiBaseUrl, window.location.origin);
      url.searchParams.set('page', String(currentPage));
      if (currentCategory) url.searchParams.set('category', currentCategory);

      try {
        const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('load failed');
        const data = await response.json();
        listings = Array.isArray(data.items) ? data.items : [];
        renderCurrentListings();
        renderPagination(data);
        return listings;
      } catch (error) {
        renderCurrentListings();
        renderPagination({ page: 1, totalPages: 1 });
        return listings;
      }
    };

    const renderDetail = (listing) => {
      if (!detailNode) return;
      if (initialListingSlug && marketplaceNode) marketplaceNode.hidden = true;
      const imageItems = Array.isArray(listing.images) ? listing.images.filter((image) => image && image.url) : [];
      const images = imageItems.length
        ? `<div class="classifieds-detail__slider" data-classifieds-slider><div class="classifieds-detail__slides">${imageItems.map((image, index) => `<figure class="classifieds-detail__slide" id="classified-slide-${escapeHtml(listing.id || listing.slug || 'listing')}-${index + 1}"><img src="${escapeHtml(image.url)}" alt="${escapeHtml(image.altText || listing.title)}" loading="${index === 0 ? 'eager' : 'lazy'}"></figure>`).join('')}</div>${imageItems.length > 1 ? `<div class="classifieds-detail__slider-nav" aria-label="Navigation des images">${imageItems.map((_, index) => `<a href="#classified-slide-${escapeHtml(listing.id || listing.slug || 'listing')}-${index + 1}" aria-label="Voir l'image ${index + 1}">${index + 1}</a>`).join('')}</div>` : ''}</div>`
        : '<div class="classifieds-detail__empty-image">Image en attente</div>';
      const categoryLabel = listing.categoryLabel || categoryLabels[listing.category] || listing.category;
      const conditionLabel = listing.conditionLabel || conditionLabels[listing.condition] || listing.condition;
      const status = String(listing.status || '').toUpperCase();
      const statusHtml = status ? `<li><span>Statut</span><strong>${escapeHtml(listingStatusLabel(status))}</strong></li>` : '';
      const statusDetail = listing.statusReason || listing.rejectionReason || listing.reviewMessage || listing.moderationNote || listing.adminNote || listing.statusDetail || '';
      const statusDetailHtml = statusDetail ? `<li><span>Detail du statut</span><strong>${escapeHtml(statusDetail)}</strong></li>` : '';
      const transport = shippingLabel(listing);
      const isOwner = Boolean(listing.isOwner || ownedListingFor(listing));
      const pseudoInputHtml = accountProfileDisplayName
        ? ''
        : '<div class="field"><input class="field__input" id="classified-contact-pseudo" name="sellerDisplayName" maxlength="255" placeholder="Pseudo public" required><label class="field__label" for="classified-contact-pseudo">Pseudo public</label></div>';
      const contactHtml = isOwner
        ? ''
        : actionBaseUrl
        ? `<form class="classifieds__contact-form" data-classifieds-contact-form data-listing-id="${escapeHtml(listing.id)}">${pseudoInputHtml}<label class="classifieds__label" for="classified-contact-message">Message au vendeur</label><textarea class="text-area field__input classifieds__textarea" id="classified-contact-message" name="body" rows="5" required></textarea><button class="button" type="submit">Contacter le vendeur</button><p class="classifieds__form-status" data-classifieds-contact-status role="status"></p></form>`
        : `<a class="button" href="${escapeHtml(loginUrl)}?return_url=${encodeURIComponent(pageUrl)}">Se connecter pour contacter le vendeur</a>`;

      detailNode.innerHTML = `<article class="classifieds-detail" tabindex="-1"><div class="classifieds-detail__header"><div><p class="classifieds__eyebrow">Annonce astronomie d'occasion</p><h2 class="title h1" id="classifieds-detail-title">${escapeHtml(listing.title)}</h2><div class="classifieds-detail__price">${escapeHtml(formatPrice(listing))}</div></div><button class="button button--secondary" type="button" data-classifieds-close>Fermer</button></div><div class="classifieds-detail__layout"><div class="classifieds-detail__gallery">${images}</div><div class="classifieds-detail__info"><ul class="classifieds-detail__facts">${statusHtml}${statusDetailHtml}<li><span>Catégorie</span><strong>${escapeHtml(categoryLabel)}</strong></li><li><span>État</span><strong>${escapeHtml(conditionLabel)}</strong></li>${[listing.brand, listing.model].filter(Boolean).length ? `<li><span>Marque / modèle</span><strong>${escapeHtml([listing.brand, listing.model].filter(Boolean).join(' '))}</strong></li>` : ''}${listing.approximateLocation ? `<li><span>Localisation</span><strong>${escapeHtml(listing.approximateLocation)}</strong></li>` : ''}${transport ? `<li><span>Remise / livraison</span><strong>${escapeHtml(transport)}</strong></li>` : ''}<li><span>Vendeur</span><strong>${escapeHtml(listing.sellerDisplayName || 'Client Astronomy Store')}</strong></li></ul><div class="classifieds-detail__description rte"><p>${escapeHtml(listing.description).replace(/\n/g, '<br>')}</p></div>${contactHtml}</div></div></article>`;
      openDetailModal();
      trackVisit(listingPath(listing.slug));
    };

    const renderUnavailableDetail = (slug, options) => {
      if (!detailNode) return;
      if (initialListingSlug && marketplaceNode) marketplaceNode.hidden = true;
      const data = options || {};
      const statusLabel = data.status ? listingStatusLabel(data.status) : data.title || 'Annonce indisponible';
      const message = data.message || unavailableMessageForStatus(data.status);
      const detailRows = [
        data.status ? `<li><span>Statut</span><strong>${escapeHtml(statusLabel)}</strong></li>` : '',
        slug ? `<li><span>Reference</span><strong>${escapeHtml(slug)}</strong></li>` : '',
        data.detail ? `<li><span>Detail</span><strong>${escapeHtml(data.detail)}</strong></li>` : ''
      ].filter(Boolean).join('');

      detailNode.innerHTML = `<article class="classifieds-detail" tabindex="-1"><div class="classifieds-detail__header"><div><p class="classifieds__eyebrow">${escapeHtml(statusLabel)}</p><h2 class="title h1" id="classifieds-detail-title">Cette annonce n’est pas disponible publiquement.</h2></div><button class="button button--secondary" type="button" data-classifieds-close>Fermer</button></div><div class="classifieds-detail__layout"><div class="classifieds-detail__empty-image">Annonce indisponible</div><div><ul class="classifieds-detail__facts">${detailRows}</ul><div class="classifieds-detail__description rte"><p>${escapeHtml(message)}</p><p>Si vous êtes le propriétaire de cette annonce, connectez-vous avec le compte utilisé pour la déposer afin de consulter son statut et ses détails.</p></div><a class="button" href="${escapeHtml(loginUrl)}?return_url=${encodeURIComponent(window.location.pathname)}">Se connecter</a></div></div></article>`;
      openDetailModal();
    };

    const openDetailModal = () => {
      if (!detailNode) return;
      detailNode.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const dialog = detailNode.querySelector('.classifieds-detail');
      const closeButton = detailNode.querySelector('[data-classifieds-close]');
      const focusTarget = closeButton || dialog;
      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
    };

    const closeDetailModal = () => {
      if (!detailNode) return;
      detailNode.hidden = true;
      detailNode.innerHTML = '';
      activeListingSlug = '';
      if (!submitOverlay || submitOverlay.hidden) document.documentElement.style.overflow = '';
      if (detailTrigger && typeof detailTrigger.focus === 'function') detailTrigger.focus({ preventScroll: true });
      detailTrigger = null;
    };

    const closeDetailAndUpdateUrl = () => {
      closeDetailModal();
      if (window.location.pathname.replace(/\/$/, '') !== basePagePath && window.history && window.history.pushState) {
        window.history.pushState({ classifiedsListingSlug: '' }, '', basePagePath + window.location.search + window.location.hash);
      }
    };

    const fetchOwnedOrStatusListing = async (slug) => {
      if (!actionBaseUrl) return null;
      if (accountUrl) {
        const accountData = await fetchJson(accountUrl, { credentials: 'include', headers: { Accept: 'application/json' } }).catch(() => null);
        const account = normalizeAccountPayload(accountData);
        const ownedListing = account.listings.find((item) => item && (item.slug === slug || item.handle === slug || item.listingSlug === slug));
        if (ownedListing) return ownedListing;
      }
      const response = await fetch(`${actionBaseUrl.replace(/\/$/, '')}/${encodeURIComponent(slug)}?format=json`, {
        credentials: 'include',
        headers: { Accept: 'application/json, text/plain;q=0.9, */*;q=0.8', 'X-Requested-With': 'XMLHttpRequest' }
      });
      const contentType = response.headers.get('content-type') || '';
      const payload = contentType.includes('application/json')
        ? await response.json().catch(() => ({}))
        : { message: await response.text().catch(() => '') };
      if (!response.ok) {
        const error = new Error(payload.error || payload.message || 'detail unavailable');
        error.status = response.status;
        error.data = payload;
        throw error;
      }
      return payload.listing || payload;
    };

    const openListing = async (slug, options = {}) => {
      if (!slug) return;
      activeListingSlug = slug;
      if (options.updateUrl && window.history && window.history.pushState) {
        const nextPath = listingPath(slug);
        if (window.location.pathname !== nextPath) {
          window.history.pushState({ classifiedsListingSlug: slug }, '', nextPath);
        }
      }
      const localListing = listings.find((listing) => listing.slug === slug);
      if (localListing) {
        renderDetail(localListing);
        setStatus('');
        return;
      }
      if (!apiBaseUrl) return;
      setStatus('Chargement de l’annonce...');
      try {
        const response = await fetch(`${apiBaseUrl.replace(/\/$/, '')}/${encodeURIComponent(slug)}`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('detail failed');
        const data = await response.json();
        renderDetail(data.listing);
        setStatus('');
      } catch (error) {
        try {
          const listing = await fetchOwnedOrStatusListing(slug);
          if (listing && (listing.id || listing.title)) {
            renderDetail(listing);
            setStatus('');
            return;
          }
          renderUnavailableDetail(slug, { message: listing && listing.message });
          setStatus('');
        } catch (fallbackError) {
          const message = (fallbackError.data && (fallbackError.data.message || fallbackError.data.error)) || fallbackError.message;
          const title = fallbackError.status === 410 ? 'Annonce supprimée' : fallbackError.status === 404 ? 'Annonce introuvable' : 'Annonce inaccessible';
          renderUnavailableDetail(slug, { title, message, detail: fallbackError.status ? `HTTP ${fallbackError.status}` : '' });
          setStatus('');
        }
      }
    };

    const openSubmit = () => {
      if (!submitOverlay) return;
      submitOverlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const firstField = submitOverlay.querySelector('input, select, textarea, button, a');
      if (firstField) firstField.focus({ preventScroll: true });
    };

    const closeSubmit = () => {
      if (!submitOverlay) return;
      submitOverlay.hidden = true;
      document.documentElement.style.overflow = '';
      resetSubmitFormMode();
    };

    root.addEventListener('click', (event) => {
      const listingLink = event.target.closest('a[href]');
      if (listingLink && !listingLink.hasAttribute('data-classifieds-open')) {
        const slug = listingSlugFromUrl(listingLink.getAttribute('href'));
        if (slug) {
          event.preventDefault();
          detailTrigger = listingLink;
          openListing(slug, { updateUrl: true });
          return;
        }
      }
      const target = event.target.closest('[data-category], [data-classifieds-open], [data-classifieds-page], [data-classifieds-close], [data-classifieds-open-submit], [data-classifieds-close-submit], [data-classifieds-open-account], [data-classifieds-close-account], [data-classifieds-edit-listing], [data-classifieds-remove-listing], [data-classifieds-email-notifications-toggle], [data-classifieds-seller], [data-classifieds-location-index]');
      if (!target) return;
      if (target.hasAttribute('data-classifieds-location-index')) {
        const index = Number(target.dataset.classifiedsLocationIndex || '-1');
        const places = locationResults && Array.isArray(locationResults._places) ? locationResults._places : [];
        const place = places[index];
        if (place) {
          event.preventDefault();
          if (locationQuery) locationQuery.value = vagueLocationFromPlace(place);
          setLocationFields(place);
        }
        return;
      }
      if (target.hasAttribute('data-classifieds-seller')) {
        event.preventDefault();
        currentSellerDisplayName = target.dataset.classifiedsSeller || '';
        currentCategory = '';
        currentPage = 1;
        root.querySelectorAll('[data-category]').forEach((button) => button.classList.remove('is-active'));
        if (window.history && window.history.pushState) window.history.pushState({ classifiedsSeller: currentSellerDisplayName }, '', sellerPath(currentSellerDisplayName));
        closeDetailModal();
        loadListings();
        return;
      }
      if (target.hasAttribute('data-classifieds-open-submit')) return openSubmit();
      if (target.hasAttribute('data-classifieds-close-submit')) return closeSubmit();
      if (target.hasAttribute('data-classifieds-open-account')) return openAccountModal(target);
      if (target.hasAttribute('data-classifieds-close-account')) return closeAccountModal();
      if (target.hasAttribute('data-classifieds-email-notifications-toggle')) {
        updateEmailNotifications();
        return;
      }
      if (target.hasAttribute('data-classifieds-remove-listing')) {
        removeAccountListing(target.dataset.classifiedsRemoveListing, target);
        return;
      }
      if (target.hasAttribute('data-classifieds-edit-listing')) {
        const listingId = target.dataset.classifiedsEditListing;
        const listing = accountListingsNode && Array.isArray(accountListingsNode._classifiedListings)
          ? accountListingsNode._classifiedListings.find((item) => item.id === listingId)
          : null;
        if (listing) {
          closeAccountModal();
          openEditListing(listing);
        }
        return;
      }
      if (target.hasAttribute('data-category')) {
        root.querySelectorAll('[data-category]').forEach((button) => button.classList.remove('is-active'));
        target.classList.add('is-active');
        currentCategory = target.dataset.category || '';
        currentPage = 1;
        loadListings();
        return;
      }
      if (target.hasAttribute('data-classifieds-open')) {
        event.preventDefault();
        detailTrigger = target;
        return openListing(target.dataset.classifiedsOpen, { updateUrl: true });
      }
      if (target.hasAttribute('data-classifieds-page')) {
        currentPage = Number(target.dataset.classifiedsPage || '1');
        loadListings();
        return;
      }
      if (target.hasAttribute('data-classifieds-close')) closeDetailAndUpdateUrl();
    });

    if (detailNode) {
      detailNode.addEventListener('click', (event) => {
        if (event.target === detailNode) closeDetailAndUpdateUrl();
      });
    }

    if (accountOverlay) {
      accountOverlay.addEventListener('click', (event) => {
        if (event.target === accountOverlay) closeAccountModal();
      });
    }

    if (window.history && window.history.replaceState) {
      window.history.replaceState({ classifiedsListingSlug: initialListingSlug || '' }, '', window.location.href);
    }

    window.addEventListener('popstate', () => {
      const slug = listingSlugFromPath();
      if (slug) {
        if (slug !== activeListingSlug) openListing(slug, { updateUrl: false });
        return;
      }
      currentSellerDisplayName = sellerFromUrl();
      closeDetailModal();
      renderCurrentListings();
    });

    if (submitOverlay) {
      submitOverlay.addEventListener('click', (event) => {
        if (event.target === submitOverlay) closeSubmit();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (accountOverlay && !accountOverlay.hidden) closeAccountModal();
      else if (detailNode && !detailNode.hidden) closeDetailModal();
      else if (submitOverlay && !submitOverlay.hidden) closeSubmit();
    });

    if (form) {
      form.setAttribute('action', actionBaseUrl || '');
      form.setAttribute('method', 'post');
      form.addEventListener('input', (event) => {
        const field = event.target;
        if (!field || !field.name) return;
        const errorNode = form.querySelector(`[data-classifieds-field-error="${field.name}"]`);
        if (errorNode) errorNode.textContent = '';
        field.classList.remove('classifieds__field--invalid');
        field.removeAttribute('aria-invalid');
        if (field === locationQuery) clearPreciseLocationFields();
      });
      if (locationQuery) {
        locationQuery.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          runLocationSearch();
        });
        locationQuery.addEventListener('blur', () => {
          if (!form.elements.locationLatitude || !form.elements.locationLatitude.value) runLocationSearch();
        });
      }
      if (shippingToggle) shippingToggle.addEventListener('change', syncShippingPayerVisibility);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        clearFormErrors();
        if (!ensureSubmitLocationAndDelivery()) return;
        if (!actionBaseUrl) {
          if (formStatus) formStatus.textContent = 'Configuration API manquante.';
          return;
        }
        if (formStatus) formStatus.textContent = 'Envoi de l’annonce...';
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) submitButton.disabled = true;
        try {
          const isEdit = form.dataset.mode === 'edit' && editingListing && editingListing.id;
          const submitUrl = isEdit ? `${actionBaseUrl.replace(/\/$/, '')}/${encodeURIComponent(editingListing.id)}` : actionBaseUrl;
          const response = await fetch(submitUrl, { method: isEdit ? 'PUT' : 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            showSubmitErrors(data, isEdit ? 'Impossible de modifier l’annonce.' : 'Impossible d’envoyer l’annonce.');
            return;
          }
          form.reset();
          clearFormErrors();
          if (formStatus) formStatus.textContent = isEdit ? 'Annonce modifiée et renvoyée à validation.' : 'Annonce envoyée. Elle sera publiée après validation automatique.';
          loadAccount();
          window.setTimeout(closeSubmit, 1600);
        } catch (error) {
          showSubmitErrors({ error: error.message }, 'Impossible d’envoyer l’annonce.');
        } finally {
          if (submitButton) submitButton.disabled = false;
        }
      });
    }

    if (searchNode) searchNode.addEventListener('input', renderCurrentListings);
    if (sortNode) sortNode.addEventListener('change', renderCurrentListings);
    root.addEventListener('submit', async (event) => {
      const contactForm = event.target.closest('[data-classifieds-contact-form]');
      if (!contactForm) return;
      event.preventDefault();
      const listingId = contactForm.dataset.listingId;
      const status = contactForm.querySelector('[data-classifieds-contact-status]');
      if (!actionBaseUrl) {
        if (status) status.textContent = 'Configuration API manquante.';
        return;
      }
      if (status) status.textContent = 'Envoi du message...';
      try {
        const response = await fetch(`${actionBaseUrl.replace(/\/$/, '')}/${encodeURIComponent(listingId)}/messages`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(contactForm) });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || 'message failed');
        contactForm.reset();
        loadAccount();
        if (status) status.textContent = 'Message envoyé au vendeur.';
      } catch (error) {
        if (status) status.textContent = error.message || 'Impossible d’envoyer le message.';
      }
    });

    trackVisit(pageUrl);
    loadListings().then(() => {
      if (initialListingSlug) openListing(initialListingSlug);
    });
    loadAccount();
  });
})();
